import React from 'react';
import SigninHeader from 'Components/Account/SigninHeader'
import Footer from './Footer';

function IntellectualProperty() {
  return (
    <div className='w-full h-full  '>
       <SigninHeader/>
       <div className='italic text-4xl flex justify-center items-center w-full h-[300px]'>
        --Intellectual property content goes here --
       </div>
       <Footer/>
    </div>
  )
}

export default IntellectualProperty